import React, { useState } from 'react'
import { Default } from 'react-toastify/dist/utils'
import MainContainer from '../../layout/MainContainer'
import { Box, Button, Checkbox, FormControlLabel, FormGroup, IconButton } from '@mui/material'
import SearchBar from '../../components/SearchBar'
import { useNavigate } from 'react-router-dom'
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FilterMenu from '../../components/filterMenu'


export const Booking = () => {
    const navigate = useNavigate();
    const goBack = () => {
        navigate(-1); // this goes one step back in history
    };
    const [searchTerm, setSearchTerm] = useState('');

    return (
        <MainContainer>
            <div className="main_title d_flex">
                <div className="left_s">
                    <h1 className="back_arrow">
                        {" "}
                        <IconButton onClick={() => goBack()}>
                            {" "}
                            <ArrowBackIcon />{" "}
                        </IconButton>{" "}
                        Booking Detail 
                    </h1>
                </div>


                <div className="right_s">
                    <div className="left_s">
                        <Box className="search_box">
                            <SearchBar
                                searchTerm={searchTerm}
                                setDebouncedSearchTerm={setSearchTerm}
                                placeholder="Search status & membership"
                            />
                        </Box>
                    </div>
                  <FilterMenu />
                </div>
            </div>


            <section className='mt_40 booking_sc'>
                <div className='cards'>
                    <div className="section_title">
                        <h2>Dining</h2>
                        <p>Cancelled</p>
                    </div>
                    <div className='dining_fdx mb_30'>
                        <figure>
                            <img src={`/static/images/booking_img.png`} alt="bookingss" />
                        </figure>
                        <div className='rt'>
                            <span className='badge' >Event</span>
                            <h2>Candlelight Symphony</h2>
                            <p>Savor the Flavors of Sucre: Where Culinary Excellence Meets Creativity</p>
                        </div>
                    </div>
                    <div className="gap_p view_page">
                        <div className="w_25">
                            <h6>Booking Date & Time</h6>
                            <p>2nd-June-2025 | 6:00PM</p>
                        </div>
                        <div className="w_25">
                            <h6>Guests</h6>
                            <p>04</p>
                        </div>
                        <div className="w_25">
                            <h6>Client Name</h6>
                            <p>John Smith</p>
                        </div>
                        <div className="w_25">
                            <h6>Client Email</h6>
                            <p>john@gmail.com</p>
                        </div>
                        <div className="w_25">
                            <h6>Client Phone</h6>
                            <p>+971 (0) 567894623</p>
                        </div>
                        <div className="w_25">
                            <h6>Location</h6>
                            <p>La Marsa, Tunesia</p>
                        </div>
                        <div className="w_25">
                            <h6>Seating preferences</h6>
                            <p>
                                <FormGroup>
                                    <FormControlLabel
                                        control={<Checkbox defaultChecked />}
                                        label="Indoor Seating"
                                    />
                                </FormGroup>
                            </p>
                        </div>
                        <div className="w_25">
                            <h6>Any special request or occassion</h6>
                            <p>Vegan/Vegetarian Meal</p>
                        </div>

                    </div>

                </div>
            </section>

        </MainContainer>
    )
}

export default Booking;
